import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-multi-brand-oil-chiller',
  templateUrl: './multi-brand-oil-chiller.component.html',
  styleUrls: ['./multi-brand-oil-chiller.component.scss']
})
export class MultiBrandOilChillerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
